export default class Card {
  constructor(args) {
    this.id = args.id;
    this.type = args.type;
    this.imageUrl = args.imageUrl;
    this.title = args.title;
    this.subtitle = args.subtitle;
    this.price = args.price;
    this.pricePerSite = args.pricePerSite || [];
    this.showPrice = args.showPrice || true;
    this.stockAmount = args.stockAmount || -1;
    this.campaignText = args.campaignText || "";
    this.campaignValue = args.campaignValue || 0;
    this.urlSafe = args.urlSafe || "";
    this.isAdded = false;
    this.isFavorite = args.isFavorite || false;
    this.notBookable = args.notBookable || false;
    this.overrideText = args.overrideText || null;
    this.description = args.description || '';
    this.showDescriptionDefault = args.showDescriptionDefault || false;
    this.rankingSource = args.rankingSource || null;
    this.idBase64 = args.idBase64 || "";
  }
}
